const w = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 3.836c0-.876.72-1.586 1.607-1.586h11.786c.887 0 1.607.71 1.607 1.586V20.98c0 1.024-1.165 1.626-2.018 1.043L12.915 18.9a1.625 1.625 0 0 0-1.83 0l-4.567 3.122c-.853.583-2.018-.02-2.018-1.043z"/></svg>';
export {
  w
};
